import React, { Suspense } from "react";
import StudentDetailsLayout from "../../../components/StudentDetailsLayout";
import { useBackgroundQuery, skipToken } from "@apollo/client";
import { getStudentTranscriptGradeLevelsQuery } from "../modules/queries";
import classes from "./GradeLevels.scss";
import GradeLevelsSkeleton from "./GradeLevelsSkeleton";
import { GradeLevelsChangesProvider, GradeLevelsProvider } from "../context";
import ActionButtons from "./ActionButtons";
const GradeLevelsContainer = React.lazy(() => import("./GradeLevelsContainer"));

const GradeLevels = ({
  params: { studentId },
  router,
  route,
  currentStudent,
  previousStudentId,
  nextStudentId,
  onStudentClick,
}) => {
  const [queryRef] = useBackgroundQuery(
    getStudentTranscriptGradeLevelsQuery,
    studentId
      ? {
          fetchPolicy: "cache-and-network",
          variables: { id: studentId },
        }
      : skipToken
  );

  return (
    <GradeLevelsProvider studentId={studentId}>
      <GradeLevelsChangesProvider>
        <StudentDetailsLayout
          currentStudent={currentStudent}
          previousStudentId={previousStudentId}
          nextStudentId={nextStudentId}
          onStudentClick={onStudentClick}
          childrenClass={classes.children}
          headerRightComponent={
            <ActionButtons
              currentStudent={currentStudent}
              studentId={studentId}
              router={router}
              route={route}
            />
          }
        >
          <Suspense fallback={<GradeLevelsSkeleton />}>
            <GradeLevelsContainer queryRef={queryRef} studentId={studentId} />
          </Suspense>
        </StudentDetailsLayout>
      </GradeLevelsChangesProvider>
    </GradeLevelsProvider>
  );
};

export default GradeLevels;
